import axios from "axios";
import { toast } from "react-toastify";
import ApiConfig from "../config/ApiConfig";
import { errorMessage } from "../lib/helper";
import { STATUS_200, STATUS_300 } from "../data/constants";
import agentAxios from "../lib/AxiosInterceptor";
import {
  setAgentList,
  setAgentListError,
  setAgentListLoading,
  setPropertyLatestDeal,
  setPropertyLatestDealError,
  setPropertyLatestDealLoading,
  setHomepagePropertyList,
  setHomepagePropertyListError,
  setHomepagePropertyListLoading,
  setTestimonialData,
  setTestimonialDataError,
  setTestimonialDataLoading,
  setHomePropertyCategoryByTypeData,
  setHomePropertyCategoryByTypeDataLoading,
  setHomePropertyCategoryByTypeDataError,
  setPropertyFilterList,
  setPropertyFilterListLoading,
  setPropertyFilterListError
} from "../redux/login";

export const GetAllPropertyListForHomepage = (paramsParameter) => {
  return async (dispatch) => {
    try {
      dispatch(setHomepagePropertyListLoading(true));
      const resp = await axios.get(
        `${ApiConfig.homepagePropertyList}`, {
        params: { ...paramsParameter },
      }
      );
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setHomepagePropertyList(resp?.data?.data));
        dispatch(setHomepagePropertyListLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setHomepagePropertyListError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setHomepagePropertyListLoading(false));
    }
  };
};
export const GetAgentListForHomepage = () => {
  return async (dispatch) => {
    try {
      dispatch(setAgentListLoading(true));
      const resp = await axios.get(`${ApiConfig.agentList}`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setAgentList(resp?.data?.data));
        dispatch(setAgentListLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setAgentListError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setAgentListLoading(false));
    }
  };
};

export const GetTestimonialsListForHomepage = (langParam) => {
  return async (dispatch) => {
    try {
      dispatch(setTestimonialDataLoading(true));
      const resp = await axios.get(`${ApiConfig.testimonialList}`, {
        params: { lang: langParam },
      });
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setTestimonialData(resp?.data?.data));
        dispatch(setTestimonialDataLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setTestimonialDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setTestimonialDataLoading(false));
    }
  };
};

export const GetHomePropertyCategoryByType = (langParam) => {
  return async (dispatch) => {
    try {
      dispatch(setHomePropertyCategoryByTypeDataLoading(true));
      const resp = await axios.get(
        `${ApiConfig.allPropertyCategory}?lang=${langParam}`
      );
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setHomePropertyCategoryByTypeData(resp?.data?.data));
        dispatch(setHomePropertyCategoryByTypeDataLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setHomePropertyCategoryByTypeDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setHomePropertyCategoryByTypeDataLoading(false));
    }
  };

};

export const GetPropertyDealListForHomepage = () => {
  return async (dispatch) => {
    try {
      dispatch(setPropertyLatestDealLoading(true));
      const resp = await axios.get(`${ApiConfig.propertyLatestDeal}`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setPropertyLatestDeal(resp?.data?.data));
        dispatch(setPropertyLatestDealLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setPropertyLatestDealError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setPropertyLatestDealLoading(false));
    }
  };
};

export const GetPropertyFilterList = (paramsParameter) => {
  return async (dispatch) => {
    try {
      dispatch(setPropertyFilterListLoading(true));

      const resp = await axios.get(`${ApiConfig.homePropertyCategory}`, {
        params: { ...paramsParameter }, // ex: { property_category_master_id: 1 }
      });

      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setPropertyFilterList(resp?.data?.data?.data || []));
        dispatch(setPropertyFilterListLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setPropertyFilterListError({
          isError: true,
          message: errorMessage(e),
        })
      );

      toast.error(errorMessage(e), {
        autoClose: 2000,
      });

      dispatch(setPropertyFilterListLoading(false));
    }
  };
};

export const GetProvinceDistrictList = () => {
  return async () => {
    try {
      const resp = await axios.get(`${ApiConfig.provinceDistrictList}`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        return resp?.data?.data || [];
      } else {
        throw resp;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return [];
    }
  };
};

// export const GetSimilarPropertyList = async (paramsParameter) => {
//   try {
//     const response = await axios.get(ApiConfig.similarproperty, {
//       params: {
//         property_category_master_id:
//           paramsParameter?.property_category_master_id,
//         property_subcategory_master_id:
//           paramsParameter?.property_subcategory_master_id,
//       },
//     });

//     if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
//       return response?.data?.data ?? [];
//     } else {
//       throw response;
//     }
//   } catch (e) {
//     const message = errorMessage(e);
//     toast.error(message, { autoClose: 2000 });
//     return [];
//   }
// };

export const GetSimilarPropertyList = (paramsParameter) => {
  return async (dispatch) => {
    try {
      dispatch(setPropertyFilterListLoading(true));

      const response = await axios.get(ApiConfig.similarproperty, {
        params: { ...paramsParameter },
      });

      if (response.status >= STATUS_200 && response.status < STATUS_300) {
        const list = response?.data?.data || [];

        dispatch(setPropertyFilterList(list));
        dispatch(setPropertyFilterListLoading(false));

        // ✅ IMPORTANT — return data to component
        return list;
      }
    } catch (e) {
      dispatch(
        setPropertyFilterListError({
          isError: true,
          message: errorMessage(e),
        })
      );

      dispatch(setPropertyFilterListLoading(false));

      // ✅ return empty array instead of throwing
      return [];
    }
  };
};
